let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cVwlN")).then(() => parcelRequire('9GPhw'));